<template>
  <div
    id="content"
    class="content"
    style="margin-left:0px;"
  >
    <h1
      class="page-header"
      style="text-align:left"
    >
      订单管理
      <small>/&nbsp;订单审核</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">订单审核列表</h4>
              </div>
              <!-- end panel-heading -->
              <!-- begin panel-body -->
              <div class="panel-body">
                <form style="margin-top:16px;padding-left:15px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">订单编号</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="订单编号"
                          v-model="orderNo"
                        >
                      </div>
                      <label class="col-md-1 col-form-label">相关渠道</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="渠道号/渠道名称"
                          v-model="fuzzyRecom"
                        >
                      </div>
                      <label class="col-md-1 col-form-label">订单时间</label>
                      <div class="col-md-3">
                        <el-date-picker
                          style="width:100%;height:34px;"
                          v-model="TimeValue"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="ChangePicker"
                        ></el-date-picker>
                      </div>
                      <div class="col-md-2"></div>
                      <label class="col-md-1 col-form-label LineSpacing">租户</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.lesseeId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                          @change="(val) => {
                              $set(form, 'deptId', undefined)
                            $set(form, 'firstAreaId', undefined)
                            $set(form, 'secondAreaId', undefined)
                            $set(form, 'thirdAreaId', undefined)
                              departmentList = []
                              regionalList = []
                               partitionList = []
                               districtList = []
                              if (val) {
                                getDeptList()
                                getAreaPageList()
                              }
                            }"
                        >
                          <el-option
                            v-for="item in lesseeList"
                            :key="item.id"
                            :label="item.lesseeName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">部门</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.deptId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                          @change="(val) => {
                            $set(form, 'firstAreaId', undefined)
                            $set(form, 'secondAreaId', undefined)
                            $set(form, 'thirdAreaId', undefined)
                              regionalList = []
                               partitionList = []
                               districtList = []
                              getAreaPageList()
                            }"
                        >
                          <el-option
                            v-for="item in departmentList"
                            :key="item.id"
                            :label="item.deptName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">大区</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.firstAreaId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                          @change="(val) => {
                            $set(form, 'secondAreaId', undefined)
                            $set(form, 'thirdAreaId', undefined)
                               partitionList = []
                               districtList = []
                              if (val) {
                                getAreaPageList()
                              }
                            }"
                        >
                          <el-option
                            v-for="item in regionalList"
                            :key="item.id"
                            :label="item.areaName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="col-md-3 LineSpacing"></div>
                      <label class="col-md-1 col-form-label LineSpacing">分区</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.secondAreaId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                          @change="(val) => {
                            $set(form, 'thirdAreaId', undefined)
                               districtList = []
                              if (val) {
                                getAreaPageList()
                              }
                            }"
                        >
                          <el-option
                            v-for="item in partitionList"
                            :key="item.id"
                            :label="item.areaName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">区域</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.thirdAreaId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in districtList"
                            :key="item.id"
                            :label="item.areaName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">企业名称</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="companyId"
                          clearable
                          placeholder="请选择"
                          style="width:100%;font-size:12px;"
                        >
                          <el-option
                            v-for="item in companyList "
                            :key="item.id "
                            :label="item.commerceName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="col-md-3 LineSpacing"></div>
                      <label class="col-md-1 col-form-label LineSpacing">订单来源</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="orderFrom"
                          clearable
                          placeholder="请选择"
                          style="width:100%;font-size:12px;"
                          @change="selectOrder"
                        >
                          <el-option
                            v-for="item in orderFromList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing" v-if="isO2O">门店名称</label>
                      <div class="col-md-2 LineSpacing" v-if="isO2O">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="门店名称"
                          v-model="shopName"
                        >
                      </div>
                      <div class="col-md-1 LineSpacing">
                        <a
                          class="btn btn-primary ButtonColor m-r-5"
                          @click="SearchClick()"
                        >查询</a>
                      </div>
                    </div>
                    <div style="margin-bottom:15px;text-align:right;">
                      <a
                        class="btn btn-warning ButtonColor"
                        @click="CancelOrder()"
                      >取消订单</a>
                      <a
                        class="btn btn-primary ButtonColor"
                        style="margin-right:16px;"
                        @click="AduitOrder()"
                      >审核放行</a>
                    </div>
                  </fieldset>
                </form>
                <el-table
                  :data="UserManagementList"
                  border
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column prop="ordernumber" label="序号" width="60" align="center"></el-table-column>
                  <el-table-column prop="orderNo" label="订单编号" width="180" align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="recom" label="渠道号" align="center" width="150" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="recomName" label="渠道名称" align="center" width="180" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="companyName" label="企业名称" align="center" width="180" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="shopName" label="门店名称" align="center" width="200" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="goodsName" label="商品名称" align="center" width="300" show-overflow-tooltip ></el-table-column>
                  <el-table-column prop="orderStatusName" label="订单状态" align="center" width="150" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="payVoucher" label="支付流水号" align="center" width="250" show-overflow-tooltip></el-table-column>
                  <el-table-column v-if="!isDesensitization" prop="buyerName" label="订购人" align="center" width="100" show-overflow-tooltip></el-table-column>
                  <el-table-column v-else prop="buyerNameNew" label="订购人" align="center" width="100" show-overflow-tooltip></el-table-column>
                  <el-table-column v-if="!isDesensitization" prop="buyerTel" label="联系方式" align="center" width="120" show-overflow-tooltip></el-table-column>
                  <el-table-column v-else prop="buyerTelNew" label="联系方式" align="center" width="120" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="buyertime" label="下单时间" align="center" width="180" show-overflow-tooltip></el-table-column>
                  <el-table-column  fixed="right" label="支付操作" width="100" align="center">
                    <template slot-scope="scope">
                    <button
                      class="btn btn-primary btn-sm ButtonColor"
                      @click="DeclareClick(scope.row)"
                      :disabled="scope.row.declaredisabled"
                    >支付申报</button>
                    </template>
                  </el-table-column>
                  <el-table-column  fixed="right"   label="审核操作" width="250" align="center">
                    <template slot-scope="scope">
                        <button
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="DetailClick(scope.row)"

                      >详情</button>
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="AduitClick(scope.row)"
                        :disabled="scope.row.aduitdisabled"
                      >审核放行</button>
                      <button
                        class="btn btn-warning btn-sm ButtonColor"
                        :disabled="scope.row.canceldisabled"
                        @click="CancelClick(scope.row)"
                      >取消订单</button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog
      title
      :visible.sync="outerVisible"
      width="500px"
    >
      <div
        v-if="EditDialog === 3"
        class="ModelPadding"
      >
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">确定{{DialogTitle}}吗?</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
      <div
        v-if="EditDialog === 2"
        class="ModelPadding"
      >
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">确定取消吗?</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSure"
            >确定</div>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="MakeCancel"
            >取消</div>
          </div>
        </div>
      </div>
      <div
        v-if="EditDialog === 1"
        class="ModelPadding"
      >
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">确定批量审核放行吗?</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureAduit"
            >确定</div>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="MakeCancel"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import {openNewTab} from '../../utils'
export default {
  name: "OrderReview",
  data() {
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      outerVisible: false,
      EditDialog: 1,
      TimeValue: "",
      orderNo: "",
      fuzzyRecom: "",
      shopName:"",
      CurrentSelection: [],
      multipleSelection: [],
      payType: "",
      orderFrom: "请选择",
      DialogTitle: "",
      CloseShows: false,
      cancelone: false,
      aduitone: false,
      disabled: false,
      cancelShow: false,
      ruleForm: {},
      rules: {
        id: [{ required: true, message: "请选择海关编号", trigger: "blur" }]
      },
      UserManagementList: [],
      orderFromList: [
        {
          label: "PC商城",
          value: "20"
        },
        {
          label: "O2O门店",
          value: "21"
        }
      ],
      isO2O:false,
      companyId:'',
      companyList:[],
      director:0,
      isDesensitization: false,
      form: {},
      lesseeList: [],
      departmentList: [],
      regionalList: [],
      partitionList: [],
      districtList: [],
    };
  },
  mounted: function() {
    if (this.$route.params && this.$route.params.searchContent) {
      this.orderNo = this.$route.params.searchContent.orderNo;
      this.fuzzyRecom = this.$route.params.searchContent.fuzzyRecom;
      this.TimeValue = this.$route.params.searchContent.TimeValue;
      if (
        this.$route.params.searchContent.TimeValue !== null &&
        this.$route.params.searchContent.TimeValue !== ""
      ) {
        this.startTime = this.FormatAllDate(
          this.$route.params.searchContent.TimeValue[0]
        );
        this.endTime = this.FormatAllDate(
          this.$route.params.searchContent.TimeValue[1]
        );
      } else {
        this.startTime = "";
        this.endTime = "";
      }
      this.orderStatus = this.$route.params.searchContent.orderStatus;
      this.orderFrom = this.$route.params.searchContent.orderFrom;
    }
    // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    this.initdata();
    // 企业列表
    this.getCompanyList();
    this.getDesensitization()
    this.getLesseeList()
  },
  watch: {
    pageNo: {
      handler(newName, oldName) {
        if (this.$route.params && this.$route.params.pageNo) {
          this.pageNo = this.$route.params.pageNo;
        }
      },
      immediate: true
    },
    pagesize: {
      handler(newName, oldName) {
        if (this.$route.params && this.$route.params.pagesize) {
          this.pageSize = this.$route.params.pagesize;
        }
      },
      immediate: true
    }
  },
  computed: {
    pageNo: {
      set(val) {
        if (val) {
          this.pageindex = val;
        }
      },
      get() {
        //console.log('我被调用了') //msg1获取值时触发
      }
    },
    pagesize: {
      set(val) {
        if (val) {
          this.pageSize = val;
        }
      },
      get() {
        //console.log('我被调用了') //msg1获取值时触发
      }
    }
  },
  methods: {
    getLesseeList () {
      let that = this
      axios.get('/distribution/lessee/getLesseeList').then(response => {
        if (response.data.code === 200) {
          that.lesseeList = response.data.data
        } else {
          http.handleEorrorCode(response, that)
        }
      })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    getDeptList () {
      let that = this
      axios.get('/distribution/dept/getDeptList', {
        params: {
          lesseeId: that.form.lesseeId
        }
      }).then(response => {
        if (response.data.code === 200) {
          that.departmentList = response.data.data
        } else {
          http.handleEorrorCode(response, that)
        }
      })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    getAreaPageList () {
      let that = this
      axios.get('/distribution/area/getAreaList', {
        params: {
          lesseeId: that.form.lesseeId,
          deptId: that.form.deptId,
          areaType: that.form.secondAreaId ? 3 : that.form.firstAreaId ? 2 : 1,
          parentId: that.form.secondAreaId ? that.form.secondAreaId : that.form.firstAreaId ? that.form.firstAreaId : 0
        }
      }).then(response => {
        if (response.data.code === 200) {
          if (that.form.secondAreaId) {
            that.districtList = response.data.data
          } else if (that.form.firstAreaId) {
            that.partitionList = response.data.data
          } else {
            that.regionalList = response.data.data
          }
        } else {
          http.handleEorrorCode(response, that)
        }
      })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    getDesensitization () {
      let that = this
      axios.get('distribution/B2cOrderInfoController/getDataDesensitization').then(res => {
        if (res.data.code === 200) {
          if (!res.data.data) {
            that.isDesensitization = true
          } else {
            that.isDesensitization = false
          }
        }
      }).catch(error => {
        http.handleHttpError(error, that)
      })
    },
    EnterSelects() {
      if (this.orderFrom != "请选择") {
        this.CloseShows = true;
      }
    },
    LeaveSelects() {
      this.CloseShows = false;
    },
    ClearSelects() {
      this.orderFrom = "请选择";
    },
    DetailClick(row) {
      let searchContent = {};
      searchContent.orderNo = this.orderNo;
      searchContent.fuzzyRecom = this.fuzzyRecom;
      searchContent.TimeValue = this.TimeValue;
      searchContent.orderFrom = this.orderFrom;
      searchContent.orderStatus = this.orderStatus;
      // this.$router.push({ path: "/orderreviewdetail" });
      localStorage.setItem(
        "goodlist",
        JSON.stringify({
          row: row,
          pageNo: this.pageindex,
          pageSize: this.pageSize,
          searchContent: searchContent
        })
      );

      openNewTab('./#/orderreviewdetail')
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    ChangePicker() {
      if (this.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.TimeValue[1]);
      } else if (this.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    selectOrder(val){
      if(val==21){
        this.isO2O = true;
      }else{
        this.isO2O = false;
        this.shopName = '';
      }
    },
    // 获取企业列表
    getCompanyList(){
      let that = this;
      const options = {
        url: "distribution/B2cOrderInfoController/parsingUser",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(response => {
          if (response.data.code == 200) {
            that.companyList = response.data.data.result;
          } else {
            http.handleEorrorCode(response, this);
          }
        })
        .catch(error => {
          http.handleEorrorCode(response, this);
        });
    },
    MakeSureEdit(formName) {
      let that = this;
      if (that.DialogTitle === "支付申报") {
        that.disabled = true;
        const options = {
          url: "distribution/B2cDeclareCustomsController/declareType",
          method: "post",
          headers: { "Content-Type": "application/json" },
          data: {
            payType: that.CurrentSelection.payType,
            orderNo: that.CurrentSelection.orderNo,
            recom: that.CurrentSelection.recom
          }
        };
        axios(options)
          .then(function(response) {
            that.outerVisible = false;
            that.disabled = false;
            if (response.data.code == 200) {
              that.initdata();
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
            } else {
              http.handleEorrorCode(response, that);
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });
      } else if (that.DialogTitle === "审核放行") {
        let orderNos = {
          orderId: this.CurrentSelection.orderId,
          orderNo: this.CurrentSelection.orderNo,
          orderStatus: this.CurrentSelection.orderStatus
        };
        let jsonData = [];
        jsonData.push({
          payType: that.CurrentSelection.payType,
          orderNo: that.CurrentSelection.orderNo,
          recom: that.CurrentSelection.recom,
          ordersVO: orderNos
        });
        that.disabled = true;
        const options = {
          url: "distribution/B2cDeclareCustomsController/declareTypeNew",
          method: "post",
          headers: { "Content-Type": "application/json" },
          data: jsonData
        };
        axios(options)
          .then(function(response) {
            that.outerVisible = false;
            that.disabled = false;
            if (response.data.code == 200) {
              that.initdata();
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
            } else if (response.data.code == 1105) {
              let messages =
                "订单审核成功" +
                response.data.data.checkSuccOrder +
                "条，" +
                "订单审核失败" +
                response.data.data.checkFailOrder +
                "条，" +
                "支付申报失败" +
                response.data.data.errorPay +
                "条";
              that.initdata();
              that.$notify({
                title: "提示",
                message: messages,
                type: "warning"
              });
            } else {
              http.handleEorrorCode(response, that);
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });
      }
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    CancelClick(row) {
      this.CurrentSelection = row;

      this.outerVisible = true;
      this.cancelone = true;
      this.EditDialog = 2;
    },
    AduitClick(row) {
      this.CurrentSelection = row;
      this.ruleForm = {};
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.outerVisible = true;
      this.aduitone = true;
      this.DialogTitle = "审核放行";
      this.EditDialog = 3;
    },
    CancelOrder() {
      if (this.multipleSelection.length === 0) {
        this.$notify({
          title: "失败",
          message: "请选择一条数据",
          type: "error"
        });
      } else {
        this.multipleSelection.forEach(element => {
          if (
            element.orderStatus !== 1 &&
            element.orderStatus !== 2 &&
            element.orderStatus !== 3 &&
            element.orderStatus !== 4
          ) {
            this.cancelShow = true;
          }
        });
        if (this.cancelShow) {
          this.$notify({
            title: "失败",
            message: "请选择正确的数据",
            type: "error"
          });
        } else {
          this.outerVisible = true;
          this.EditDialog = 2;
        }
      }
    },
    MakeCancel() {
      this.outerVisible = false;
      this.aduitone = false;
      this.cancelone = false;
      this.cancelShow = false;
    },
    AduitOrder() {
      if (this.multipleSelection.length === 0) {
        this.$notify({
          title: "失败",
          message: "请选择一条数据",
          type: "error"
        });
      } else {
        this.outerVisible = true;
        this.EditDialog = 1;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    initdata() {
      let that = this;
      let orderFrom = "";
      if (that.orderFrom === "请选择") {
        orderFrom = "";
      } else {
        orderFrom = that.orderFrom;
      }
      const options = {
        url: "distribution/B2cOrderInfoController/getCancelAuditOrders",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          director: that.director,
          size: that.pageSize,
          current: that.pageindex,
          orderNo: that.orderNo,
          fuzzyRecom: that.fuzzyRecom,
          orderFrom: orderFrom,
          shopName: that.shopName,
          cid: that.companyId,
          startTime: that.startTime,
          endTime: that.endTime,
          lesseeId: that.form.lesseeId,
          deptId: that.form.deptId,
          firstAreaId: that.form.firstAreaId,
          secondAreaId: that.form.secondAreaId,
          thirdAreaId: that.form.thirdAreaId
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.totalCount = response.data.data.totalCount;
          that.cancelShow = false;
          for (var i in response.data.data.data) {
            if (
              response.data.data.data[i].orderStatus === 1 ||
              response.data.data.data[i].orderStatus === 2 ||
              response.data.data.data[i].orderStatus === 3 ||
              response.data.data.data[i].orderStatus === 4
            ) {
              response.data.data.data[i].canceldisabled = false;
            } else {
              response.data.data.data[i].canceldisabled = true;
            }
            if (
              response.data.data.data[i].orderStatus === 3 ||
              response.data.data.data[i].orderStatus === 4
            ) {
              response.data.data.data[i].aduitdisabled = false;
            } else {
              response.data.data.data[i].aduitdisabled = true;
            }
            if (
              response.data.data.data[i].orderStatus === 3 ||
              response.data.data.data[i].orderStatus === 4 ||
              response.data.data.data[i].orderStatus === 5
            ) {
              response.data.data.data[i].declaredisabled = false;
            } else {
              response.data.data.data[i].declaredisabled = true;
            }
            response.data.data.data[i].ordernumber =
              Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
            if (response.data.data.data[i].buyerTime !== null) {
              response.data.data.data[i].buyertime = that.FormatAllDate(
                response.data.data.data[i].buyerTime
              );
            } else {
              response.data.data.data[i].buyertime = "";
            }
            switch (response.data.data.data[i].orderStatus) {
              case 0:
                response.data.data.data[i].orderstatus = "取消订单";
                break;
              case 1:
                response.data.data.data[i].orderstatus = "购物车";
                break;
              case 2:
                response.data.data.data[i].orderstatus = "已提交，未支付";
                break;
              case 3:
                response.data.data.data[i].orderstatus = "已支付";
                break;
              case 4:
                response.data.data.data[i].orderstatus = "拦截";
                break;
              case 5:
                response.data.data.data[i].orderstatus = "审核放行，流转到中台";
                break;
              case 6:
                response.data.data.data[i].orderstatus = "已发货";
                break;
              case 7:
                response.data.data.records[i].orderstatus = "已收货";
                break;
              case 8:
                response.data.data.data[i].orderstatus = "交易成功";
                break;
              case 9:
                response.data.data.data[i].orderstatus = "售后";
                break;
              case 10:
                response.data.data.data[i].orderstatus = "退货";
                break;
              case 11:
                response.data.data.data[i].orderstatus = "退款";
                break;
              case 12:
                response.data.data.data[i].orderstatus = "换货";
                break;
              case 13:
                response.data.data.data[i].orderstatus = "交易关闭";
            }
          }

          that.UserManagementList = response.data.data.data;
        } else {
          http.handleEorrorCode(response, that);
        }
      });
    },
    DeclareClick(item) {
      this.outerVisible = true;
      this.EditDialog = 3;
      this.DialogTitle = "支付申报";
      this.CurrentSelection = item;
      this.ruleForm = {};
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
    },
    MakeSure() {
      let that = this;
      let orderNos = [];
      if (this.cancelone) {
        orderNos.push({
          orderId: this.CurrentSelection.orderId,
          orderNo: this.CurrentSelection.orderNo,
          orderStatus: this.CurrentSelection.orderStatus
        });
      } else {
        this.multipleSelection.forEach(val => {
          orderNos.push({
            orderId: val.orderId,
            orderNo: val.orderNo,
            orderStatus: val.orderStatus
          });
        });
      }

      that.disabled = true;
      const options = {
        url: "distribution/B2cOrderInfoController/deleteOrders",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: {
          orderNos: orderNos,
          orderStatus: that.CurrentSelection.orderStatus
        }
      };
      axios(options)
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          that.cancelone = false;
          that.cancelShow = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          that.outerVisible = false;
          that.cancelShow = false;
          that.disabled = false;
          that.cancelone = false;
          http.handleHttpError(error, that);
        });
    },
    MakeSureAduit() {
      let that = this;
      that.disabled = true;
      let jsonData = [];
      this.multipleSelection.forEach(val => {
        let orderNos = {
          orderId: val.orderId,
          orderNo: val.orderNo,
          orderStatus: val.orderStatus
        };
        jsonData.push({
          payType: val.payType,
          orderNo: val.orderNo,
          recom: val.recom,
          ordersVO: orderNos
        });
      });
      const options = {
        url: "distribution/B2cDeclareCustomsController/declareTypeNew",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: jsonData
      };
      axios(options)
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          that.aduitone = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else if (response.data.code == 1105) {
            let messages =
              "订单审核成功" +
              response.data.data.checkSuccOrder +
              "条，" +
              "订单审核失败" +
              response.data.data.checkFailOrder +
              "条，" +
              "支付申报失败" +
              response.data.data.errorPay +
              "条";
            that.initdata();
            that.$notify({
              title: "提示",
              message: messages,
              type: "warning"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          that.outerVisible = false;
          that.disabled = false;
          that.aduitone = false;
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderManage/OrderReview.vue